import { decodeEntities } from "./text";

const STANDARD_GTIN_LENGTHS = new Set([8, 12, 13, 14]);
const MIN_BARCODE_LENGTH = 8;
const MAX_BARCODE_LENGTH = 14;

function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

export function normalizeBarcode(value: string): string | null {
  const gs1 = value.match(/\(01\)\s*((?:\d[\s-]?){14})/i)
    ?? value.match(/(?:\]C1|\]d2)\s*01\s*((?:\d[\s-]?){14})/i);
  const digits = digitsOnly(gs1?.[1] ?? value);
  return digits.length >= MIN_BARCODE_LENGTH && digits.length <= MAX_BARCODE_LENGTH
    ? digits
    : null;
}

export function extractBarcodes(...values: Array<string | null | undefined>): string[] {
  const matches = new Set<string>();
  const text = decodeEntities(
    values
      .filter((value): value is string => Boolean(value))
      .join("\n")
      .replace(/<(?:br|\/p|\/li|\/td|\/th|\/tr|\/div|\/h\d)>/gi, "\n")
      .replace(/<[^>]*>/g, " "),
  );
  const labeledCode = /\b(?:U\.?P\.?C\.?(?:-A)?|EAN(?:-13)?|GTIN(?:-14)?|barcode)\s*(?:(?:codes?|numbers?|nos?\.?)\s*)?(?::|#|is\b|-)?\s*((?:\d[\s-]?){7,13}\d)(?!\d)/gi;

  for (const match of text.matchAll(labeledCode)) {
    const normalized = normalizeBarcode(match[1] ?? "");
    if (normalized) matches.add(normalized);
  }
  return [...matches];
}

export type BarcodeConfidence = "exact" | "possible";

export function compareBarcodes(scanned: string, published: string): BarcodeConfidence | null {
  const left = normalizeBarcode(scanned);
  const right = normalizeBarcode(published);
  if (!left || !right) return null;
  if (left === right) return "exact";
  if (
    STANDARD_GTIN_LENGTHS.has(left.length)
    && STANDARD_GTIN_LENGTHS.has(right.length)
    && left.padStart(14, "0") === right.padStart(14, "0")
  ) {
    return "exact";
  }
  if (
    Math.abs(left.length - right.length) <= 2
    && (left.includes(right) || right.includes(left))
  ) {
    return "possible";
  }
  return null;
}
